import React from 'react';
import PropTypes from 'prop-types';

import ApprovalStatuses from "../constants/approval_statuses";

export default class FinalActivityMessage extends React.Component {
	static propTypes = {
		approvalStatus: PropTypes.oneOf(Object.keys(ApprovalStatuses).map((k) => ApprovalStatuses[k])),
		rejectionCustomFinishMessage: PropTypes.string,
		approvalCustomFinishMessage: PropTypes.string,
		canDismiss: PropTypes.bool
	};

	static defaultProps = {
		approvalStatus: null,
		rejectionCustomFinishMessage: null,
		approvalCustomFinishMessage: null,
		canDismiss: false
	};

	parseFlashType() {
		const { approvalStatus } = this.props;

		switch(approvalStatus) {
			case ApprovalStatuses.APPROVED:
			return 'success';
			case ApprovalStatuses.REJECTED:
			default:
			return 'error';
		}
	}

	getFinalActivityMessageByApprovalStatus() {
		const { approvalStatus, rejectionCustomFinishMessage, approvalCustomFinishMessage } = this.props;

		switch(approvalStatus) {
			case ApprovalStatuses.APPROVED:
			return approvalCustomFinishMessage;
			case ApprovalStatuses.REJECTED:
			return rejectionCustomFinishMessage;
		}
	}

	renderMessage() {
		return (
			<div className="final-activity-message">
			<p> <strong>{Realize.i18n.t('activity.messages.finalActivity')}.</strong></p>
			<p>{this.getFinalActivityMessageByApprovalStatus()}</p>
			</div>
		);
	}

	render() {
		return (
			<Flash
			message={this.renderMessage()}
			type={this.parseFlashType()}
			canDismiss={this.props.canDismiss}
			/>
		);
	}
}
